import React from 'react';
import { Box, FormError, TextInput, TextInputProps } from 'pounceV2';
import { FieldConfig, useField } from 'formik';
import { safeguardErrorMsg } from '../utils';

interface FormikTextInputProps extends TextInputProps {
  noWhiteSpace: boolean;
  uppercase: boolean;
}
export const FormikTextInputV3: React.FC<
  FormikTextInputProps & Required<Pick<FieldConfig, 'name'>>
> = props => {
  const [, meta, helpers] = useField(props.name);

  const isInvalid = meta.touched && !!meta.error;
  const errorElementId = isInvalid ? `${props.name}-error` : undefined;

  const { setValue } = helpers;

  React.useEffect(() => {
    if (props.noWhiteSpace) {
      setValue(meta.value.replace(/\s/g, ''));
    }
  }, [meta.value, props.noWhiteSpace, setValue]);

  React.useEffect(() => {
    if (props.uppercase) {
      setValue(meta.value.toUpperCase());
    }
  }, [meta.value, props.uppercase, setValue]);

  return (
    <Box>
      <TextInput
        invalid={isInvalid}
        aria-describedby={isInvalid ? errorElementId : undefined}
        {...props}
      />
      {isInvalid && (
        <FormError mt={2} id={errorElementId}>
          {safeguardErrorMsg(meta.error)}
        </FormError>
      )}
    </Box>
  );
};
